import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
function DossierTableNoResult({ filters }) {
    const { formattedFilterMessage } = useFormattedFilterMessage(filters);
    return _jsx(_Fragment, { children: formattedFilterMessage });
}
function formatFilterName(t, key, value) {
    const filterLabel = t(`dossier.filters.${key}.label`);
    const filterValueTranslationKey = `dossier.filters.${key}.values.${value}`;
    const filterValueFromTranslation = t(filterValueTranslationKey);
    const filterValue = filterValueFromTranslation !== filterValueTranslationKey
        ? filterValueFromTranslation
        : value;
    return { label: filterLabel, value: filterValue };
}
function useFormattedFilterMessage(filters) {
    const { t } = useTranslation();
    const formattedFilterMessage = React.useMemo(() => {
        const { status, ...otherFilters } = filters || {};
        const query = Object.entries(otherFilters || {})
            .filter(([, rawValue]) => {
            return Boolean(rawValue);
        })
            .map(([key, rawValue]) => {
            return formatFilterName(t, key, rawValue);
        })
            .map(({ label, value }) => {
            return {
                formattedLabel: label.trim().toLocaleLowerCase(),
                formattedValue: Array.isArray(value)
                    ? value.join(', ')
                    : (value || '').trim(),
            };
        })
            .map(({ formattedLabel, formattedValue }) => {
            return `${formattedLabel}: ${formattedValue}`;
        })
            .join(', ');
        const { value } = formatFilterName(t, 'status', `${status || 'open'}`.toLocaleLowerCase());
        return t('dossier.no_result', { query, status: value });
    }, [filters, t]);
    return { formattedFilterMessage };
}
export default DossierTableNoResult;
